import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { PollWrapperSchema } from "./types";

export const PollAlignment: FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<PollWrapperSchema>();

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{t("Button alignment")}</FormLabel>
      <Controller
        control={control}
        name="poll.answer_type.alignment"
        render={({ field }) => (
          <RadioGroup row {...field}>
            <FormControlLabel value="horizontal" control={<Radio />} label={t("Horizontal")} />
            <FormControlLabel value="vertical" control={<Radio />} label={t("Vertical")} />
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};
